<template>
  <div
    class="px-2"
    style="border: 1px solid var(--border-color-subtle)"
  />
</template>
